import { ResponseGoogleRecaptchaVM } from "models/responseGoogleRecaptchaVM";

const apiUrlBase = process.env.REACT_APP_API_URL_BASE;
const apiUrlController = 'googleRecaptcha/';
const apiUrlBaseController = apiUrlBase + apiUrlController;
const apiApiKey = process.env.REACT_APP_API_APIKEY + '';
const recaptchaSecret = process.env.REACT_APP_RECAPTCHA_SECRET + '';

export async function siteVerify(token: string) {
    const apiUrlBaseControllerEndpoint = apiUrlBaseController + 'verifySite';
    let model = new ResponseGoogleRecaptchaVM();

    try {
        let formData = new FormData();
        formData.append("Secret", recaptchaSecret);
        formData.append("Response", token);

        const response = await fetch(apiUrlBaseControllerEndpoint, {
            method: 'POST',
            headers: {
                'XApiKey': apiApiKey
            },
            body: formData 
        });

        model = await response.json();
        
        return model;

    } catch (error: any) {
        return model;
    }
}